import { BaseError } from './BaseError.js';
import { CLIENT_ERROR_MESSAGES, type ClientErrorCode } from './constants.js';

/**
 * Custom Error class to be used within payment flow (see createPayment).
 * Every intentional exception within the payment flow should use this Error class with a significant error code.
 */
// export class PaymentError<TClientCode = ClientErrorCode> extends BaseError<TClientCode> {
// export class PaymentError<TClientCode extends ClientErrorCode = ClientErrorCode> extends BaseError<TClientCode> {
export class PaymentError extends BaseError<ClientErrorCode> {
  constructor({
    clientCode,
    code,
    extraData,
    message: errorMessage,
  }: {
    clientCode: ClientErrorCode;
    code?: string;
    extraData?: object;
    message?: string;
  }) {
    const paymentMessage = CLIENT_ERROR_MESSAGES[clientCode];

    const message = errorMessage ?? paymentMessage;

    super({ clientCode, code, extraData, message });

    this.name = 'PaymentError';
  }
}
